import { render, staticRenderFns } from "./BasketItemConsentCheck.vue?vue&type=template&id=81cfde24&"
import script from "./BasketItemConsentCheck.vue?vue&type=script&lang=js&"
export * from "./BasketItemConsentCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\bensz\\Documents\\Frontend Studios\\plentyDevTool\\35627\\43\\easygroundVueTheme\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81cfde24')) {
      api.createRecord('81cfde24', component.options)
    } else {
      api.reload('81cfde24', component.options)
    }
    module.hot.accept("./BasketItemConsentCheck.vue?vue&type=template&id=81cfde24&", function () {
      api.rerender('81cfde24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/checkout/BasketItemConsentCheck.vue"
export default component.exports